import React, { useEffect } from "react";
import FrontLayout from "../../../components/layout-new-theme/FrontLayout";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { getPageContents } from "../../../actions/admin/cmspage";
import { useLoading } from "../../../components/LoadingContext";


const tlf_logo_2 = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/tlf_logo_2.svg";
const tlf_logo_2_mobile = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/tlf-logo-2-mobile.svg";
const jpt_logo = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/jpt_logo.svg";
const jpt_logo_mobile = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/jpt_logo_mobile.svg";
const vehicle_in_city = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/vehicle_in_city.png";
const jpt_corporate = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/jpt_corporate.png";
const Corporate = () => {
  const page_name = "cms-corporate";
  const dispatch = useDispatch();
  const cmspage_state = useSelector((state) => state.cmspage);
  const { cmspage, loading } = cmspage_state;
  const { i18n } = useTranslation();
  const lang = i18n.language?.toUpperCase();
  useEffect(() => {
    dispatch(getPageContents(page_name));
  }, [dispatch]);
  const { showLoading, closeLoading } = useLoading();
  return (
    <FrontLayout>
      {loading ? showLoading(true) : closeLoading(true)}
      {/* <!-- hero --> */}
      <div
        className="hero-image-corporate tw:flex tw:items-end"
        style={{
          background:
            "url('" +
            (lang === "EN"
              ? cmspage?.page_content_en.image2
              : cmspage?.page_content_jp.image2) +
            "')",
        }}
      >
        <div className="tw:w-full tw:mx-auto tw:sm:max-w-[540px] tw:md:max-w-[720px] tw:lg:max-w-[960px] tw:xl:max-w-[1140px] tw:2xl:max-w-[1320px] tw:md:w-[91.6667%] tw:md:flex-none tw:lg:w-3/4 tw:lg:flex-none tw:pt-8 tw:mb-0 tw:lg:pb-12">
          <div className="tw:p-4 tw:md:p-0 tw:w-full tw:flex-none tw:flex tw:flex-col tw:justify-end">
            <p
              className="tw:bg-transparent tw:border-0 tw:py-2 tw:px-4 tw:mb-0! tw:[font-family:var(--font-sans-primary)]! tw:font-bold tw:tracking-[3px] tw:text-[0.5rem]! tw:uppercase tw:pl-0 text-gold"
              dangerouslySetInnerHTML={{
                __html:
                  lang === "EN"
                    ? cmspage?.page_content_en.content1
                    : cmspage?.page_content_jp.content1,
              }}
            >
              {/* {t("About.Us")} */}
            </p>
            <div
              className="tw:mb-2 tw:md:mb-4 tw:text-[34px] tw:lg:text-[45px] tw:font-libre-caslon-display tw:leading-[58px] tw:text-white tw:font-normal tw:sm:w-[443px]"
              dangerouslySetInnerHTML={{
                __html:
                  lang === "EN"
                    ? cmspage?.page_content_en.content2
                    : cmspage?.page_content_jp.content2,
              }}
            >
              {/* {t("Corporate.Profile")} */}
            </div>
            <p
              className="tw:w-full tw:flex-none tw:md:w-[58.3333%] tw:md:flex-none text-gold intro tw:mb-12 tw:lg:mb-0"
              dangerouslySetInnerHTML={{
                __html:
                  lang === "EN"
                    ? cmspage?.page_content_en.content3
                    : cmspage?.page_content_jp.content3,
              }}
            >
              {/* {t("Corporate.Profile.Intro")} */}
            </p>
          </div>
        </div>
      </div>
      <section className="custom-mt-7">
        <div className="tw:w-full tw:mx-auto tw:sm:max-w-[540px] tw:md:max-w-[720px] tw:lg:max-w-[960px] tw:xl:max-w-[1140px] tw:2xl:max-w-[1320px] tw:mx-0 tw:md:mx-auto">
          <div className="tw:flex tw:flex-wrap">
            <div className="tw:md:w-1/2 tw:w-1/1 tw:md:flex-none tw:p-0">
              <div className="bg-burgundy" style={{ height: "200px" }}>
                <div className="tw:flex tw:flex-wrap tw:items-center tw:h-full tw:px-2 tw:md:px-12 tw:py-4">
                  <div className="tw:w-full tw:w-1/1 tw:md:w-1/4 tw:md:flex-none">
                    <div className="tw:flex tw:justify-center">
                      <img
                        className="tw:hidden! tw:md:block!"
                        src={tlf_logo_2}
                        alt="logo"
                      />
                      <img
                        className="tw:block! tw:md:hidden!"
                        src={tlf_logo_2_mobile}
                        alt="logo-mobile"
                        srcset=""
                      />
                    </div>
                  </div>
                  <div className="tw:w-full tw:w-1/1 tw:md:w-3/4 tw:md:flex-none">
                    <div className="tw:md:ml-4 tw:text-center tw:md:text-left tw:pt-0">
                      <p
                        className="noto tw:bg-transparent tw:border-0 tw:py-2 tw:px-0! tw:mb-0! tw:[font-family:var(--font-sans-primary)] tw:font-bold tw:tracking-[3px] tw:text-[0.5rem]! tw:uppercase text-gold"
                        dangerouslySetInnerHTML={{
                          __html:
                            lang === "EN"
                              ? cmspage?.page_content_en.content2
                              : cmspage?.page_content_jp.content2,
                        }}
                      ></p>
                      <h2 className="text-gold tw:mb-0!">THE LUXURY FLEET</h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="tw:md:w-1/2 tw:w-1/1 tw:md:flex-none tw:p-0">
              <div className="tw:bg-white">
                <img
                  className="tw:w-full"
                  src={vehicle_in_city}
                  alt="logo"
                  style={{ height: "200px", objectFit: "cover" }}
                />
              </div>
            </div>
          </div>
          <div className="tw:flex tw:flex-wrap tw:p-0">
            <div className="tw:w-full tw:flex-none tw:lg:w-1/2 tw:lg:flex-none tw:p-12">
              <h5
                dangerouslySetInnerHTML={{
                  __html:
                    lang === "EN"
                      ? cmspage?.page_content_en.content9
                      : cmspage?.page_content_jp.content9,
                }}
              ></h5>
              <p
                className="tw:mt-4"
                dangerouslySetInnerHTML={{
                  __html:
                    lang === "EN"
                      ? cmspage?.page_content_en.content10
                      : cmspage?.page_content_jp.content10,
                }}
              ></p>
            </div>
            <div className="tw:w-full tw:flex-none tw:lg:w-1/2 tw:lg:flex-none tw:p-12">
              <h5
                dangerouslySetInnerHTML={{
                  __html:
                    lang === "EN"
                      ? cmspage?.page_content_en.content11
                      : cmspage?.page_content_jp.content11,
                }}
              ></h5>
              <p
                className="tw:mt-4"
                dangerouslySetInnerHTML={{
                  __html:
                    lang === "EN"
                      ? cmspage?.page_content_en.content12
                      : cmspage?.page_content_jp.content12,
                }}
              ></p>
            </div>
          </div>
        </div>
        <div className="tw:w-full tw:mx-auto tw:sm:max-w-[540px] tw:md:max-w-[720px] tw:lg:max-w-[960px] tw:xl:max-w-[1140px] tw:2xl:max-w-[1320px] tw:mx-0 tw:md:mx-auto">
          <div className="tw:flex tw:flex-wrap">
            <div className="tw:md:w-1/2 tw:w-1/1 tw:md:flex-none tw:p-0">
              <div className="bg-black" style={{ height: "200px" }}>
                <div className="tw:flex tw:flex-wrap tw:items-center tw:h-full tw:px-2 tw:md:px-12 tw:py-4">
                  <div className="tw:w-full tw:w-1/1 tw:md:w-1/4 tw:md:flex-none">
                    <div className="tw:flex tw:justify-center">
                      <img
                        className="tw:hidden! tw:md:block!"
                        src={jpt_logo}
                        alt="logo"
                      />
                      <img
                        className="tw:block! tw:md:hidden!"
                        src={jpt_logo_mobile}
                        alt="logo-mobile"
                        srcset=""
                      />
                    </div>
                  </div>
                  <div className="tw:w-full tw:w-1/1 tw:md:w-3/4 tw:md:flex-none">
                    <div className="tw:md:ml-4 tw:text-center tw:md:text-left tw:pt-0">
                      <p
                        className="noto tw:bg-transparent tw:border-0 tw:py-2 tw:px-0! tw:mb-0! tw:[font-family:var(--font-sans-primary)] tw:font-bold tw:tracking-[3px] tw:text-[0.5rem]! tw:uppercase text-white"
                        dangerouslySetInnerHTML={{
                          __html:
                            lang === "EN"
                              ? cmspage?.page_content_en.content2
                              : cmspage?.page_content_jp.content2,
                        }}
                      ></p>
                      <h2 className="text-white tw:mb-0!">JAPAN PRIVATE TOUR</h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="tw:md:w-1/2 tw:w-1/1 tw:md:flex-none tw:p-0">
              <div className="tw:bg-white">
                <img
                  className="tw:w-full"
                  src={jpt_corporate}
                  alt="logo"
                  style={{ height: "200px", objectFit: "cover" }}
                />
              </div>
            </div>
          </div>
          <div className="tw:flex tw:flex-wrap tw:p-0">
            <div className="tw:w-full tw:flex-none tw:lg:w-1/2 tw:lg:flex-none tw:p-12">
              <h5
                dangerouslySetInnerHTML={{
                  __html:
                    lang === "EN"
                      ? cmspage?.page_content_en.content9
                      : cmspage?.page_content_jp.content9,
                }}
              ></h5>
              <p
                className="tw:mt-4"
                dangerouslySetInnerHTML={{
                  __html:
                    lang === "EN"
                      ? cmspage?.page_content_en.content13
                      : cmspage?.page_content_jp.content13,
                }}
              ></p>
            </div>
            <div className="tw:w-full tw:flex-none tw:lg:w-1/2 tw:lg:flex-none tw:p-12">
              <h5
                dangerouslySetInnerHTML={{
                  __html:
                    lang === "EN"
                      ? cmspage?.page_content_en.content11
                      : cmspage?.page_content_jp.content11,
                }}
              ></h5>
              <p
                className="tw:mt-4"
                dangerouslySetInnerHTML={{
                  __html:
                    lang === "EN"
                      ? cmspage?.page_content_en.content14
                      : cmspage?.page_content_jp.content14,
                }}
              ></p>
            </div>
          </div>
        </div>
      </section>
    </FrontLayout>
  );
};

export default Corporate;
